(() => {
  const q=(s,r=document)=>r.querySelector(s), qa=(s,r=document)=>[...r.querySelectorAll(s)];
  const drawer=q('[data-cart-drawer]');
  const openDrawer=()=>{if(drawer){drawer.setAttribute('aria-hidden','false');drawer.classList.add('is-open');q('.drawer-backdrop')?.classList.add('is-open');}};
  const closeDrawer=()=>{if(drawer){drawer.setAttribute('aria-hidden','true');drawer.classList.remove('is-open');q('.drawer-backdrop')?.classList.remove('is-open');}};
  qa('[data-cart-open]').forEach(b=>b.addEventListener('click',openDrawer));
  qa('[data-cart-close]').forEach(b=>b.addEventListener('click',closeDrawer));
  // Mobile menu is wired once below in the final navigation handler.
  qa('.product-form').forEach(form=>form.addEventListener('submit',async e=>{
    if(!drawer)return;
    e.preventDefault(); const btn=q('button[type=submit]',form); btn?.classList.add('is-loading');
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
      if(!r.ok)throw new Error();
      const cart=await fetch('/cart.js').then(x=>x.json());
      const count=q('[data-cart-count]'); if(count)count.textContent=cart.item_count;
      const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cart.currency||'USD'});
      const total=q('[data-cart-total]'); if(total)total.textContent=money.format(cart.total_price/100);
      const items=q('[data-cart-items]');
      if(items)items.innerHTML=cart.items.map(i=>`<div class="drawer-item"><img src="${i.image||''}" alt=""><div><b>${i.product_title}</b><span>${i.quantity} × ${money.format(i.price/100)}</span></div></div>`).join('');
      openDrawer();
    }catch(err){form.submit()}finally{btn?.classList.remove('is-loading')}
  }));
  q('[data-filter-toggle]')?.addEventListener('click',()=>q('[data-filters]')?.classList.toggle('is-open'));
})();
/* Zonix premium product interactions — stable gallery + variant + cart */
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-product-page]').forEach(page=>{
    const slides=[...page.querySelectorAll('[data-media-slide]')];
    const thumbs=[...page.querySelectorAll('[data-media-target]')];
    let mediaIndex=Math.max(0,slides.findIndex(s=>s.classList.contains('is-active')));
    if(mediaIndex<0) mediaIndex=0;
    const setMediaByIndex=(index)=>{
      if(!slides.length)return;
      mediaIndex=(index+slides.length)%slides.length;
      slides.forEach((s,i)=>{const active=i===mediaIndex;s.classList.toggle('is-active',active);s.hidden=!active;});
      thumbs.forEach((t,i)=>{
        const active=i===mediaIndex;
        t.classList.toggle('is-active',active);
        t.setAttribute('aria-selected',active?'true':'false');
      });
    };
    const setMediaById=(id)=>{
      const i=slides.findIndex(s=>String(s.dataset.mediaSlide)===String(id) || String(s.dataset.imageSlide)===String(id));
      if(i>-1)setMediaByIndex(i);
      return i;
    };
    thumbs.forEach(t=>{
      t.addEventListener('mouseenter',()=>setMediaById(t.dataset.mediaTarget));
      t.addEventListener('focus',()=>setMediaById(t.dataset.mediaTarget));
      t.addEventListener('click',()=>setMediaById(t.dataset.mediaTarget));
    });
    const gallery=page.querySelector('[data-product-gallery]');
    gallery?.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>setMediaByIndex(mediaIndex-1));
    gallery?.querySelector('[data-gallery-next]')?.addEventListener('click',()=>setMediaByIndex(mediaIndex+1));
    gallery?.addEventListener('keydown',e=>{if(e.key==='ArrowLeft')setMediaByIndex(mediaIndex-1);if(e.key==='ArrowRight')setMediaByIndex(mediaIndex+1);});
    setMediaByIndex(mediaIndex);

    const form=page.querySelector('[data-product-form]');
    const variantId=page.querySelector('[data-variant-id]');
    const radios=[...page.querySelectorAll('.zonix-product-option input[type="radio"]')];
    const variants=window.__ZONIX_VARIANTS__||[];
    const addButton=page.querySelector('[data-add-to-cart]');
    const priceCurrent=page.querySelector('.zonix-price-current');
    const priceCompare=page.querySelector('.zonix-price-compare');
    const priceSale=page.querySelector('.zonix-price-sale');
    const formatMoney=(cents)=>{
      const currency=document.documentElement.dataset.currency||window.Shopify?.currency?.active||'USD';
      try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency}).format(Number(cents)/100)}catch(e){return (Number(cents)/100).toFixed(2)}
    };
    const updateVariant=()=>{
      if(!form||!variants.length)return;
      const selected=[];
      radios.forEach(input=>{
        if(input.checked){
          const option=input.closest('.zonix-product-option');
          if(option)selected[Number(option.dataset.optionIndex)]=input.value;
        }
      });
      const match=variants.find(v=>v.options.every((o,i)=>o===selected[i]));
      if(!match)return;
      if(variantId)variantId.value=match.id;
      if(priceCurrent)priceCurrent.textContent=formatMoney(match.price);
      if(priceCompare){
        if(match.compare_at_price&&Number(match.compare_at_price)>Number(match.price)){
          priceCompare.textContent=formatMoney(match.compare_at_price);priceCompare.hidden=false;
        }else priceCompare.hidden=true;
      }
      if(priceSale){
        if(match.compare_at_price&&Number(match.compare_at_price)>Number(match.price)){
          const pct=Math.round((Number(match.compare_at_price)-Number(match.price))*100/Number(match.compare_at_price));
          priceSale.textContent=`${pct}% OFF`;priceSale.hidden=false;
        }else priceSale.hidden=true;
      }
      if(addButton){
        addButton.disabled=!match.available;
        addButton.textContent=match.available?'ADD TO CART':'SOLD OUT';
      }
      const featuredId=match.featured_media_id ?? match.featured_image_id;
      if(featuredId!==null&&featuredId!==undefined){
        const found=setMediaById(featuredId);
        const target=found>-1 ? thumbs[found] : page.querySelector(`[data-media-target="${CSS.escape(String(featuredId))}"], [data-image-target="${CSS.escape(String(featuredId))}"]`);
        target?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
      }
    };
    radios.forEach(r=>r.addEventListener('change',updateVariant));
    page.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{const q=page.querySelector('[data-quantity]');if(q)q.value=Math.max(1,(parseInt(q.value,10)||1)-1);});
    page.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{const q=page.querySelector('[data-quantity]');if(q)q.value=Math.max(1,(parseInt(q.value,10)||1)+1);});
    page.querySelector('[data-quantity]')?.addEventListener('change',e=>{e.target.value=Math.max(1,parseInt(e.target.value,10)||1);});
    updateVariant();

    const modal=page.querySelector('[data-size-guide-modal]');
    page.querySelector('[data-size-guide]')?.addEventListener('click',()=>{if(modal)modal.hidden=false;});
    page.querySelectorAll('[data-size-guide-close]').forEach(b=>b.addEventListener('click',()=>{if(modal)modal.hidden=true;}));
    const lightbox=page.querySelector('[data-image-lightbox]');
    const lbimg=page.querySelector('[data-lightbox-image]');
    page.querySelectorAll('[data-zoom]').forEach(b=>b.addEventListener('click',()=>{if(!lightbox||!lbimg)return;lbimg.src=b.dataset.zoom;lbimg.alt=b.getAttribute('aria-label')||'';lightbox.hidden=false;}));
    page.querySelector('[data-lightbox-close]')?.addEventListener('click',()=>{if(lightbox)lightbox.hidden=true;});
    lightbox?.addEventListener('click',e=>{if(e.target===lightbox)lightbox.hidden=true;});
    page.querySelector('[data-copy-link]')?.addEventListener('click',async()=>{try{await navigator.clipboard.writeText(window.location.href);const b=page.querySelector('[data-copy-link]');b.textContent='Link copied';setTimeout(()=>b.textContent='Copy product link',1800);}catch(e){}});
  });
});

/* ZONIX FINAL interactions */
document.addEventListener('DOMContentLoaded',()=>{
  const triggers=[...document.querySelectorAll('[data-mega-trigger]')];
  const panels=[...document.querySelectorAll('[data-mega-panel]')];
  const closeMega=()=>{panels.forEach(p=>p.hidden=true);triggers.forEach(t=>t.setAttribute('aria-expanded','false'))};
  triggers.forEach(t=>t.addEventListener('click',e=>{e.stopPropagation();const key=t.dataset.megaTrigger;const panel=document.querySelector(`[data-mega-panel="${key}"]`);const open=panel&&!panel.hidden;closeMega();if(panel&&!open){panel.hidden=false;t.setAttribute('aria-expanded','true')}}));
  document.addEventListener('click',e=>{if(!e.target.closest('.mega-menus')&&!e.target.closest('.nav-mega-trigger'))closeMega()});
  const toggle=document.querySelector('[data-menu-toggle]'), mobile=document.querySelector('[data-mobile-menu]');
  if(toggle && mobile){
    toggle.addEventListener('click',(e)=>{
      e.preventDefault();
      e.stopPropagation();
      const open=mobile.hidden===false;
      mobile.hidden=open;
      mobile.classList.toggle('is-open',!open);
      toggle.setAttribute('aria-expanded',String(!open));
      toggle.setAttribute('aria-label',open?'Open menu':'Close menu');
    });
  }
  document.querySelectorAll('[data-mobile-submenu]').forEach(b=>b.addEventListener('click',()=>{const sub=b.nextElementSibling;if(sub){sub.hidden=!sub.hidden;b.querySelector('span').textContent=sub.hidden?'+':'−'}}));

  const initZonixHeroSliders=()=>{
    document.querySelectorAll('[data-hero-slider]').forEach(slider=>{
      if(slider.dataset.heroInitialized==='true')return;
      const slides=[...slider.querySelectorAll('[data-hero-slide]')], dots=[...slider.querySelectorAll('[data-hero-dot]')], progress=slider.querySelector('[data-hero-progress]');
      if(slides.length<2)return;
      slider.dataset.heroInitialized='true';
      let index=Math.max(0,slides.findIndex(s=>s.classList.contains('is-active'))),timer=null;
      const speed=Math.max(3000,Number(slider.dataset.speed)||6000);
      const show=i=>{
        index=(i+slides.length)%slides.length;
        slides.forEach((s,n)=>{const active=n===index;s.classList.toggle('is-active',active);s.setAttribute('aria-hidden',active?'false':'true');});
        dots.forEach((d,n)=>{const active=n===index;d.classList.toggle('is-active',active);d.setAttribute('aria-current',active?'true':'false');});
        if(progress){progress.style.transition='none';progress.style.width='0%';requestAnimationFrame(()=>{progress.style.transition=`width ${speed}ms linear`;progress.style.width='100%'})}
      };
      const stop=()=>{if(timer){clearInterval(timer);timer=null}};
      const startAuto=()=>{stop();if(slider.dataset.autoplay!=='false')timer=setInterval(()=>show(index+1),speed)};
      const restart=()=>startAuto();
      slider.querySelector('[data-hero-next]')?.addEventListener('click',()=>{show(index+1);restart()});
      slider.querySelector('[data-hero-prev]')?.addEventListener('click',()=>{show(index-1);restart()});
      dots.forEach(d=>d.addEventListener('click',()=>{show(Number(d.dataset.heroDot));restart()}));
      // Do not pause on hover: preview users often leave the pointer over the hero.
      document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else startAuto()});
      show(index);startAuto();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initZonixHeroSliders,{once:true});else initZonixHeroSliders();
});

/* ZONIX — collection product rotation: four products at a time, every 12 seconds */
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-product-carousel]').forEach(carousel=>{
    const track=carousel.querySelector('[data-product-track]');
    const cards=[...carousel.querySelectorAll('.collection-product-card')];
    const prev=carousel.querySelector('[data-collection-prev]');
    const next=carousel.querySelector('[data-collection-next]');
    const dotsWrap=carousel.parentElement.querySelector('[data-product-dots]');
    if(!track||cards.length===0)return;
    let page=0,timer=null;
    const perPage=()=>window.innerWidth<=760?1:(window.innerWidth<=1100?3:4);
    const pageCount=()=>Math.max(1,Math.ceil(cards.length/perPage()));
    const renderDots=()=>{
      if(!dotsWrap)return;
      dotsWrap.innerHTML='';
      for(let i=0;i<pageCount();i++){
        const b=document.createElement('button');
        b.type='button'; b.setAttribute('aria-label',`Show product set ${i+1}`); b.className=i===page?'is-active':'';
        b.addEventListener('click',()=>{show(i);restart()});
        dotsWrap.appendChild(b);
      }
    };
    const show=p=>{
      const pp=perPage(), count=pageCount();
      page=(p+count)%count;
      const first=page*pp, last=first+pp;
      cards.forEach((card,i)=>card.classList.toggle('is-visible-product',i>=first&&i<last));
      dotsWrap?.querySelectorAll('button').forEach((b,i)=>b.classList.toggle('is-active',i===page));
      if(prev)prev.disabled=count<=1;
      if(next)next.disabled=count<=1;
    };
    const stop=()=>{if(timer)clearInterval(timer);timer=null};
    const start=()=>{stop();if(pageCount()>1)timer=setInterval(()=>show(page+1),12000)};
    const restart=()=>start();
    prev?.addEventListener('click',()=>{show(page-1);restart()});
    next?.addEventListener('click',()=>{show(page+1);restart()});
    carousel.addEventListener('mouseenter',stop);
    carousel.addEventListener('mouseleave',start);
    window.addEventListener('resize',()=>{page=Math.min(page,pageCount()-1);renderDots();show(page);start()});
    renderDots(); show(0); start();
  });
});

/* ZONIX PDP — description tabs / normalized product information */
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-description-tabs]').forEach(panel=>{
    const source=panel.querySelector('.zonix-description-source,.product-description-source');
    const tabs=panel.querySelector('.zonix-description-tabs,.description-tabs');
    const content=panel.querySelector('[data-description-content]');
    if(!source||!tabs||!content)return;

    const html=source.innerHTML.trim();
    const names=['Product Overview',"Why You'll Love It",'Key Features','Product Details','Available Colors',"What's Included",'Perfect For'];
    const normalize=s=>s.toLowerCase().replace(/[’']/g,"'").replace(/\s+/g,' ').trim();
    const escaped=names.map(n=>n.replace(/[.*+?^${}()|[\\]\\]/g,'\\$&')).join('|');
    const re=new RegExp('(?:<strong[^>]*>|<h[2-6][^>]*>|<p[^>]*>\\s*<strong[^>]*>)\\s*('+escaped+')\\s*(?:<\\/strong>\\s*(?:<\\/p>)?|<\\/h[2-6]>)','gi');
    const matches=[...html.matchAll(re)];
    const parsed={};
    let intro='';

    if(matches.length){
      intro=html.slice(0,matches[0].index).trim();
      matches.forEach((m,i)=>{
        const key=normalize(m[1]);
        parsed[key]=html.slice(m.index+m[0].length,i<matches.length-1?matches[i+1].index:html.length).trim();
      });
    }else{
      intro=html;
    }

    const fallbackTitle='Information not available for this product';
    const fallback=`<div class="zonix-tab-empty"><strong>${fallbackTitle}</strong><p>This product does not currently include verified information for this section. Please check the product details or contact Zonix Lifestyle for assistance.</p></div>`;
    const overview=parsed[normalize('Product Overview')] || intro;

    tabs.innerHTML='';
    names.forEach((name,i)=>{
      const key=normalize(name);
      const secHtml=(key===normalize('Product Overview') ? overview : parsed[key]) || fallback;
      const b=document.createElement('button');
      b.type='button';
      b.textContent=name;
      b.className=i===0?'is-active':'';
      b.setAttribute('aria-selected',i===0?'true':'false');
      b.addEventListener('click',()=>{
        tabs.querySelectorAll('button').forEach(x=>{x.classList.remove('is-active');x.setAttribute('aria-selected','false')});
        b.classList.add('is-active');
        b.setAttribute('aria-selected','true');
        content.innerHTML=secHtml;
      });
      tabs.appendChild(b);
    });
    content.innerHTML=overview || fallback;
  });
});

/* ZONIX V9 — cart quantity, remove and live totals */
document.addEventListener('DOMContentLoaded',()=>{
  let cartPage=document.querySelector('[data-cart-page]');
  if(!cartPage)return;
  const money=(cents)=>{
    const currency=window.Shopify?.currency?.active||document.documentElement.dataset.currency||'USD';
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency}).format(Number(cents)/100)}catch(e){return (Number(cents)/100).toFixed(2)}
  };
  let busy=false;
  const updateLine=async(item,key,quantity)=>{
    if(busy)return; busy=true; cartPage.classList.add('is-loading');
    try{
      const response=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
      if(!response.ok)throw new Error('Cart update failed');
      await refreshCart();
    }catch(error){window.location.reload();}
    finally{busy=false;cartPage.classList.remove('is-loading');}
  };
  const refreshCart=async()=>{
    const html=await fetch(`${window.location.pathname}?section_id=main`).then(r=>r.text());
    const doc=new DOMParser().parseFromString(html,'text/html');
    const fresh=doc.querySelector('[data-cart-page]');
    if(!fresh)throw new Error('Cart markup missing');
    cartPage.replaceWith(fresh);
    cartPage=fresh;
    bindCart(cartPage);
    const count=document.querySelector('[data-cart-count]');
    if(count){
      const countMatch=fresh.querySelector('.zonix-cart-heading p')?.textContent.match(/\d+/);
      if(countMatch)count.textContent=countMatch[0];
    }
  };
  const bindCart=(root)=>{
    root.querySelectorAll('[data-cart-minus]').forEach(btn=>btn.onclick=()=>{
      const row=btn.closest('[data-cart-item]');const input=row?.querySelector('[data-cart-input]');if(row&&input)updateLine(row,row.dataset.lineKey,Math.max(0,(parseInt(input.value,10)||1)-1));
    });
    root.querySelectorAll('[data-cart-plus]').forEach(btn=>btn.onclick=()=>{
      const row=btn.closest('[data-cart-item]');const input=row?.querySelector('[data-cart-input]');if(row&&input)updateLine(row,row.dataset.lineKey,Math.max(1,(parseInt(input.value,10)||1)+1));
    });
    root.querySelectorAll('[data-cart-remove]').forEach(btn=>btn.onclick=()=>{
      const row=btn.closest('[data-cart-item]');if(row)updateLine(row,row.dataset.lineKey,0);
    });
    root.querySelectorAll('[data-cart-input]').forEach(input=>input.addEventListener('change',()=>{
      const row=input.closest('[data-cart-item]');if(row)updateLine(row,row.dataset.lineKey,Math.max(0,parseInt(input.value,10)||0));
    }));
  };
  bindCart(cartPage);
});

/* ZONIX COLLECTION — premium filtering and sorting controls */
document.addEventListener('DOMContentLoaded',()=>{
  const filterPanel=document.querySelector('[data-filters]');
  const filterToggle=document.querySelector('[data-filter-toggle]');
  const sortSelect=document.querySelector('[data-collection-sort]');
  if(filterToggle&&filterPanel){
    filterToggle.addEventListener('click',()=>{
      const open=filterPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded',String(open));
      document.body.classList.toggle('collection-filter-open',open);
    });
  }
  sortSelect?.addEventListener('change',e=>{
    const url=new URL(window.location.href);
    url.searchParams.set('sort_by',e.target.value);
    url.searchParams.delete('page');
    window.location.href=url.toString();
  });
  filterPanel?.querySelectorAll('input[type="checkbox"]').forEach(input=>input.addEventListener('change',()=>{
    const form=input.closest('form');
    if(form)form.submit();
  }));
});

/* ZONIX — world-filtered collections index */
document.addEventListener('DOMContentLoaded',()=>{
  const grid=document.querySelector('.collections-index-grid[data-world-filter]') || document.querySelector('.collections-index-grid');
  if(!grid)return;
  const cards=[...grid.querySelectorAll('.collection-index-card')];
  if(!cards.length)return;
  const params=new URLSearchParams(window.location.search);
  const world=(params.get('world')||'').toLowerCase();
  if(!world)return;
  const labels={women:'Women Collections',men:'Men Collections',automation:'Automation Collections','new-arrivals':'New Arrivals Collections',accessories:'Accessories Collections'};
  const visible=cards.filter(card=>card.dataset.world===world);
  cards.forEach(card=>card.hidden=!visible.includes(card));
  const empty=document.querySelector('[data-collections-filter-empty]');
  if(empty)empty.hidden=visible.length>0;
  const heading=document.querySelector('[data-collections-index-head] h2');
  if(heading&&labels[world])heading.textContent=labels[world];
  const count=document.querySelector('[data-collections-count]');
  if(count)count.textContent=`${visible.length} ${visible.length===1?'collection':'collections'}`;
});
